import Page from "~/pages/Page";
import { getApi, handleError, logout } from "~/auth";
import UI from "~/ui";
import $ from "jquery";
import { gotoLogin } from "~/utils";
import { uploadDocumentoGara } from "~/services/documentService";
import { t } from "~/hooks/useI18n";



// ✅ Importa utility validazione file
import {
    ALLOWED_FILE_EXTENSIONS,
    validateAndShowFileError,
    formatFileSize,
    showFileError,
    clearFileError,
    showCustomFileError,
    clearCustomFileError,
    validateMaskedFileInputWithBorder
} from "~/utils/fileValidation";


class AdCaricaPropostaControfirmata extends Page {

    private UserId: number = 0; // Aggiungi l'ID dell'utente
    private userInfo: any = null; // Variabile globale per memorizzare le informazioni dell'utente
    private auth: any = null;
    private offerenteId: number = 0 // Id offerente dell'offerta che il venditore sta accettando

    constructor() {
        super("adcaricapropostacontrofirmata", "AD Proposta Acquisto Controfirmata");
    }

    async pageStart(): Promise<void> {
        const that = this;

        this.auth = getApi();
        this.userInfo = this.auth.getCached("userInfo"); // Inizializza la variabile globale
        if (!this.userInfo) {
            gotoLogin();
            return Promise.reject("User not authenticated");
        }

        $(".btnDowloadPiaControfirmata").on("click", async function (e) {
            e.preventDefault();
            const offertaId = $(this).data("idofferta");
            if (!offertaId) return;
            await that.DowloadPdfPIA(offertaId);
        });

        $("#btnInviaPropostaControfirmata").on("click", async function (e) {
            e.preventDefault();

            await that.UploadPdfPIAControfirmata();
        });


        // ✅ Validazione file PIA mascherato con bordo rosso
        $("#OffertaFilePiaControfirmata").on("change", function () {
            const fileInput = this as HTMLInputElement;
            if (fileInput.files && fileInput.files.length > 0) {
                validateMaskedFileInputWithBorder(fileInput, fileInput.files[0], "filePiaContrName");
            }
        });

    }

    private async DowloadPdfPIA(offertaId: number): Promise<void> {
        let _ = this.spinner.spin();
        //const url = window.BaseUrlWeb + "Venditore/DownloadPdfPIA?offertaId=" + offertaId;
        const url = window.BaseUrlWebApi + "AstaDinamica/DownloadPdfPIA?offertaId=" + offertaId;
        try {
            const response = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (!response) {
                throw new Error("Errore durante la generazione del PDF");
            }

            const blob = await response;
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "PropostaDiAcquistoConAccettazione.pdf";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.info("Errore durante la generazione del pdf:", error);
            return;
        } finally {
            this.spinner.stop();
        }
    }

    private async UploadPdfPIAControfirmata(): Promise<boolean> {
        const fileInputPiaControfirmata = document.getElementById("OffertaFilePiaControfirmata") as HTMLInputElement;
        if (fileInputPiaControfirmata && fileInputPiaControfirmata.files && fileInputPiaControfirmata.files.length > 0) {

            const tipoDocumento = "PIAC";
            const resultSaveAllegato: any = await this.SalvaDocumentoGara(tipoDocumento, fileInputPiaControfirmata);
            console.log("Result Save Allegato Pia Conrofirmata:", resultSaveAllegato)

            if (!resultSaveAllegato.success) {

                // ✅ Estrai il messaggio (supporta sia JSON che stringa semplice)
                let errorMessage = t("messages.errorUploadingFile");
                try {
                    const errorData = typeof resultSaveAllegato.message === "string"
                        ? JSON.parse(resultSaveAllegato.message)
                        : resultSaveAllegato.message;
                    errorMessage = errorData?.Message || resultSaveAllegato.message || errorMessage;
                } catch {
                    errorMessage = resultSaveAllegato.message || errorMessage;
                }

                const errorBody = `<span class="text-danger">${fileInputPiaControfirmata.files[0].name}</span>: ${errorMessage}`;

                UI.confirmOneButton(t("common.atAttention"), errorBody, "", (result) => {
                    if (result) {
                        this.resetFileInput(fileInputPiaControfirmata, "filePiaContrName");
                    }
                });

                return false;
            } else {

                const messaggio = "<p><strong>L'operazione è avvenuta con successo!</strong></p><p>L'offerente riceverà una e-mail con la notifica dell'accettazione della sua offerta.</p>"
                UI.confirmOneButtonCustom("", messaggio, "Torna alla tua area riservata", "md-lg", function (result) {
                    if (result) {
                        window.location.href = window.BaseUrlWeb + "monitora-vendita-" + Number($("#hdVenditaId").val());
                    }
                });
            }


            $(".divUploadFile").removeClass("border-primary");
            $(".divUploadFileError").addClass("d-none");
            return true;

        } else {
            $(".divUploadFile").addClass("border-primary");
            $(".divUploadFileError").removeClass("d-none");
            return true;
        }
    }


    private async SalvaDocumentoGara(tipoDocumento: string, fileInput: any, descrizione?: string): Promise<any> {
        if (fileInput?.files?.length) {
            const file = fileInput.files[0];
            const maxSize = 4 * 1024 * 1024; // 4 MB in bytes

            // ✅ Controllo dimensione file
            if (file.size > maxSize) {
                // Mostra errore sotto l'input
                showFileError(fileInput, t("messages.fileTooLargeWithSize", { size: formatFileSize(file.size) }));
                return {
                    success: false,
                    message: t("messages.fileTooLargeMax4MB")
                };
            }

            // ✅ Rimuovi eventuali errori precedenti
            clearFileError(fileInput);

            const data = {
                UserId: Number($("#hdOfferenteId").val()),
                VenditaId: Number($("#hdVenditaId").val()),
                Tipo: tipoDocumento,
                OffertaId: Number($("#hdOffertaId").val()),
                file: fileInput.files[0],
                descrizione: descrizione,
            };

            try {
                const allegatoGara: any = await uploadDocumentoGara(data);

                console.info("Allegato Gara:", allegatoGara.AllegatoId);

                return allegatoGara;
            } catch (error) {
                return { success: false, message: t("messages.errorUploadingDocument") };
            }
        }
    }

    /**
     * Resetta completamente un input file e il suo display associato
     */
    private resetFileInput(fileInput: HTMLInputElement, displayId: string): void {
        $(fileInput).val("");
        clearCustomFileError(fileInput);
        $(`#${displayId}`).empty();
    }

}

export default AdCaricaPropostaControfirmata;  